/**
 * Canonical Company Workspace product-exposure gate.
 *
 * Build-time CRA env: REACT_APP_COMPANY_WORKSPACE_ENABLED
 *
 * Semantics (only explicit normalized "false" disables):
 *   unset / empty  -> enabled
 *   true           -> enabled
 *   " true "       -> enabled
 *   false          -> disabled
 *   " FALSE "      -> disabled
 *   anything else  -> enabled
 *
 * This is a product exposure gate, not a security boundary.
 *
 * Production/browser builds must use CRA DefinePlugin substitution of
 * `process.env.REACT_APP_COMPANY_WORKSPACE_ENABLED` (module-scope capture).
 * Do not gate the default on a runtime process-existence check — browsers have
 * no global `process`, which previously forced the unset/enabled path even
 * when the built bundle contained `"false"`.
 */

export function parseCompanyWorkspaceEnabled(rawValue) {
  if (rawValue === undefined || rawValue === null) {
    return true;
  }
  const normalized = String(rawValue).trim().toLowerCase();
  if (normalized === '') {
    return true;
  }
  if (normalized === 'false') {
    return false;
  }
  return true;
}

// CRA replaces this identifier at build time with the literal env string (or
// undefined). Captured once at module evaluation so production browsers never
// need a global `process` object at call time.
const BUILD_TIME_COMPANY_WORKSPACE_ENABLED =
  process.env.REACT_APP_COMPANY_WORKSPACE_ENABLED;

/**
 * @param {object|undefined} [overrideEnv]
 *   Optional explicit env map for tests. When omitted, uses the CRA build-time
 *   value captured above. Pass `{}` / `{ REACT_APP_COMPANY_WORKSPACE_ENABLED }`
 *   to exercise the pure parser seam without touching the build boundary.
 */
export function isCompanyWorkspaceEnabled(overrideEnv) {
  if (overrideEnv !== undefined) {
    const raw = Object.prototype.hasOwnProperty.call(
      overrideEnv,
      'REACT_APP_COMPANY_WORKSPACE_ENABLED',
    )
      ? overrideEnv.REACT_APP_COMPANY_WORKSPACE_ENABLED
      : undefined;
    return parseCompanyWorkspaceEnabled(raw);
  }
  return parseCompanyWorkspaceEnabled(BUILD_TIME_COMPANY_WORKSPACE_ENABLED);
}
